<script setup lang="ts">
import { MenuClosedIcon } from '@fond-of/satch-icons'
</script>

<template>
  <MenuClosedIcon />
</template>

<style scoped>
svg:deep(.translation) {
  display: none;
}

svg:deep(.translation.de:lang(de)) {
  display: block;
}

html:not([lang='de']) svg:deep(.translation.en) {
  display: block;
}
</style>
